import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7868c2b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-center align-center ga-1 mb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-medium-emphasis mr-1" }, "Ver por", -1))
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap justify-center align-center ga-1 mb-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-medium-emphasis mr-1" }, "Ordenar por", -1))
const _hoisted_5 = {
  key: 1,
  class: "text-center py-6"
}
const _hoisted_6 = {
  key: 2,
  class: "text-body-2 text-error text-center"
}
const _hoisted_7 = {
  key: 3,
  class: "text-body-2 text-medium-emphasis text-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 font-weight-bold mb-1" }, " Ganan partidas, pero no torneos ", -1))
const _hoisted_9 = {
  key: 1,
  class: "text-body-2 text-medium-emphasis text-center"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"fila-torneos cabecera text-caption text-medium-emphasis\" data-v-7868c2b4><span data-v-7868c2b4>Ejército</span><span class=\"text-right\" data-v-7868c2b4>Torn.</span><span class=\"text-right\" data-v-7868c2b4>1º</span><span class=\"text-right\" data-v-7868c2b4>Podios</span><span class=\"text-right\" data-v-7868c2b4>% vict.</span></div>", 1)
const _hoisted_11 = ["onClick", "onKeydown"]
const _hoisted_12 = { class: "nombre" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption text-medium-emphasis mt-2 mb-0" }, " Torneos, ligas y copas individuales con clasificación final. Podio es quedar 1º, 2º o 3º, y el ejército es el que más llevó cada jugador en sus partidas de ese evento. ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fila cabecera text-caption text-medium-emphasis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ejército"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Part."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "% vict."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-right" }, "Rinde")
], -1))
const _hoisted_18 = ["onClick", "onKeydown"]
const _hoisted_19 = { class: "nombre" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "text-caption text-medium-emphasis mt-2 mb-0" }
const _hoisted_22 = { class: "text-center mt-1" }

import { computed, ref, watch } from "vue";
import type {
  EjercitoBalanceDTO,
  FiltroEstadisticas,
} from "@/interfaces/Estadisticas";
import { getRankingEjercitos } from "@/services/EstadisticasService";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import {
  POCAS_PARTIDAS,
  colorBando,
  colorRinde,
  textoPorcentaje,
  textoRinde,
} from "@/utils/estadisticasEjercitos";

const MINIMO = 10;
const MINIMO_TORNEOS = 10;
const PORCENTAJE_ALTO = 55;


export default /*#__PURE__*/_defineComponent({
  __name: 'RankingEjercitos',
  props: {
    filtro: {}
  },
  emits: ["ver"],
  setup(__props: any, { emit: __emit }) {

const ORDENES = [
  { valor: "porcentaje", texto: "% victorias" },
  { valor: "rinde", texto: "Rinde" },
  { valor: "partidas", texto: "Partidas" },
] as const;

const props = __props;
const emit = __emit;

const filas = ref<EjercitoBalanceDTO[]>([]);
const cargando = ref(false);
const error = ref<string | null>(null);
const busqueda = ref<string | null>("");
const orden = ref<(typeof ORDENES)[number]["valor"]>("porcentaje");
const todos = ref(false);
const vista = ref<"partidas" | "torneos">("partidas");

// Para decir que a un ejército «no le da para ganar» hacen falta bastantes torneos y un buen % de victorias
const cargar = async () => {
  cargando.value = true;
  error.value = null;
  try {
    filas.value = await getRankingEjercitos(
      props.filtro,
      todos.value ? 1 : MINIMO
    );
  } catch (e) {
    error.value = mensajeDelBack(
      e,
      "No se han podido cargar las estadísticas. Inténtalo de nuevo."
    );
  } finally {
    cargando.value = false;
  }
};
watch([() => props.filtro, todos], cargar, { deep: true, immediate: true });

// Sin distinguir mayúsculas ni tildes
const normalizar = (texto: string) =>
  texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// Los que han jugado algún torneo, del que más gana al que menos
const porTorneos = computed(() => {
  const buscado = normalizar(busqueda.value ?? "");
  return filas.value
    .filter(
      fila =>
        fila.torneos > 0 &&
        (!buscado || normalizar(fila.ejercito).includes(buscado))
    )
    .sort(
      (a, b) =>
        b.torneosGanados - a.torneosGanados ||
        b.podios - a.podios ||
        b.porcentaje - a.porcentaje ||
        b.torneos - a.torneos
    );
});

const sinRematar = computed(() =>
  porTorneos.value
    .filter(
      f =>
        f.torneos >= MINIMO_TORNEOS &&
        f.porcentaje >= PORCENTAJE_ALTO &&
        f.torneosGanados === 0
    )
    .sort((a, b) => b.porcentaje - a.porcentaje)
);

const visibles = computed(() => {
  const buscado = normalizar(busqueda.value ?? "");
  return filas.value
    .filter(fila => !buscado || normalizar(fila.ejercito).includes(buscado))
    .sort((a, b) => b[orden.value] - a[orden.value] || b.partidas - a.partidas);
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      modelValue: busqueda.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((busqueda).value = $event)),
      placeholder: "Buscar ejército",
      "prepend-inner-icon": "mdi-magnify",
      variant: "outlined",
      density: "compact",
      clearable: "",
      "hide-details": "",
      class: "mb-2"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_v_chip, {
        size: "small",
        color: vista.value === 'partidas' ? 'primary' : undefined,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (vista.value = 'partidas'))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Partidas ")
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_chip, {
        size: "small",
        color: vista.value === 'torneos' ? 'primary' : undefined,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (vista.value = 'torneos'))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Torneos ")
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    (vista.value === 'partidas')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ORDENES, (opcion) => {
            return _createVNode(_component_v_chip, {
              key: opcion.valor,
              size: "small",
              color: orden.value === opcion.valor ? 'primary' : undefined,
              onClick: ($event: any) => (orden.value = opcion.valor)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opcion.texto), 1)
              ]),
              _: 2
            }, 1032, ["color", "onClick"])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1))
        : (visibles.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(busqueda.value
          ? "Ningún ejército coincide con la búsqueda."
          : "No hay partidas con estos filtros."), 1))
          : (vista.value === 'torneos')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (sinRematar.value.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 0,
                      variant: "tonal",
                      color: "warning",
                      class: "pa-3 mb-3"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sinRematar.value, (fila) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: fila.ejercito,
                            class: "text-body-2"
                          }, _toDisplayString(fila.ejercito) + ": " + _toDisplayString(_unref(textoPorcentaje)(fila.porcentaje)) + " de victorias y ninguno de sus " + _toDisplayString(fila.torneos) + " torneos (" + _toDisplayString(fila.podios) + " " + _toDisplayString(fila.podios === 1 ? "podio" : "podios") + ") ", 1))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (porTorneos.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Ningún ejército ha jugado torneos individuales con estos filtros. "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_10,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(porTorneos.value, (fila) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: fila.ejercito,
                          class: "fila-torneos pulsable text-body-2",
                          role: "button",
                          tabindex: "0",
                          onClick: ($event: any) => (emit('ver', fila.ejercito)),
                          onKeydown: _withKeys(($event: any) => (emit('ver', fila.ejercito)), ["enter"])
                        }, [
                          _createElementVNode("span", _hoisted_12, [
                            _createVNode(_component_v_icon, {
                              color: _unref(colorBando)(fila.bando),
                              size: "10",
                              class: "mr-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-circle")
                              ]),
                              _: 2
                            }, 1032, ["color"]),
                            _createTextVNode(_toDisplayString(fila.ejercito), 1)
                          ]),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(fila.torneos), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-right", { 'font-weight-bold oro': fila.torneosGanados > 0 }])
                          }, _toDisplayString(fila.torneosGanados), 3),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(fila.podios), 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(textoPorcentaje)(fila.porcentaje)), 1)
                        ], 40, _hoisted_11))
                      }), 128)),
                      _hoisted_16
                    ], 64))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (fila) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: fila.ejercito,
                    class: "fila pulsable text-body-2",
                    role: "button",
                    tabindex: "0",
                    onClick: ($event: any) => (emit('ver', fila.ejercito)),
                    onKeydown: _withKeys(($event: any) => (emit('ver', fila.ejercito)), ["enter"])
                  }, [
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_v_icon, {
                        color: _unref(colorBando)(fila.bando),
                        size: "10",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-circle")
                        ]),
                        _: 2
                      }, 1032, ["color"]),
                      _createTextVNode(_toDisplayString(fila.ejercito), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-right", { 'text-medium-emphasis': fila.partidas < _unref(POCAS_PARTIDAS) }])
                    }, [
                      _createTextVNode(_toDisplayString(fila.partidas), 1),
                      (fila.partidas < _unref(POCAS_PARTIDAS))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("*")
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(textoPorcentaje)(fila.porcentaje)), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-right", _unref(colorRinde)(fila.rinde)])
                    }, _toDisplayString(_unref(textoRinde)(fila.rinde)), 3)
                  ], 40, _hoisted_18))
                }), 128)),
                _createElementVNode("p", _hoisted_21, " * Menos de " + _toDisplayString(_unref(POCAS_PARTIDAS)) + " partidas: tómalo con cautela. ", 1)
              ], 64)),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_v_btn, {
        variant: "text",
        size: "small",
        color: "primary",
        class: "text-none",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (todos.value = !todos.value))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(todos.value
            ? `Solo los de ${MINIMO} partidas o más`
            : `Ver también los de menos de ${MINIMO} partidas`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})